<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5" align="center" justify="center">
          <v-col cols="6" md="6">
            <v-card :loading="loading">
              <v-card-text class="py-0">
                <v-row class="align-center">
                  <v-col cols="12">
                    <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{ i18n['updatePlan'] }}</div>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <div v-if="formErrors.general" class="error-message">
                      <p v-for="error in formErrors.general" :key="error">{{ error }}</p>
                    </div>
                    <v-form ref="form" @submit.prevent="submitPlans">
                      <v-row>
                        <v-col cols="12">
                                <v-switch v-model="is_free" :class="[{'arFont': arabic, 'enFont': !arabic},'mb-2']" label="Is Free" color="success" dense inset>
                                </v-switch>
                            </v-col>
                            <v-col cols="6" v-if="!is_free">
                              <v-text-field outlined dense v-model="price_id" :label="i18n['price_id']"
                                :class="`${arabic ? 'arFont' : 'enFont'}`"
                                :rules="[rules.requiredIfNotFree]" required></v-text-field>
                            </v-col>

                        <v-col cols="6">
                          <v-text-field outlined dense v-model="title" :label="i18n['title']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]" disabled></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field  outlined dense v-model="title_ar" :label="i18n['title_ar']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]" disabled></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field outlined dense v-model="description" :label="i18n['description']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field outlined dense v-model="description_ar" :label="i18n['description_ar']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>


                        <v-col cols="6">
                          <v-text-field outlined dense v-model="price" :label="i18n['price']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field outlined dense v-model="compare_price" :label="i18n['compare_price']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field outlined dense v-model="form_number" :label="i18n['form_number']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field outlined dense v-model="form_submissions" :label="i18n['form_submission']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field outlined dense v-model="form_views" :label="i18n['form_views']"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" required
                            :rules="[rules.required]"></v-text-field>
                        </v-col>


                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-btn color="success" @click="addField" class="mb-2"
                            :class="{ 'arFont': arabic, 'enFont': !arabic }" small>{{ i18n['add_feature'] }}</v-btn>
                          <v-expansion-panels accordion>
                            <v-expansion-panel v-for="(field, index) in features" :key="index">
                              <v-expansion-panel-header :class="{ 'arFont': arabic, 'enFont': !arabic }">
                                {{ i18n['feature'] }} {{ index + 1 }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <v-text-field outlined dense v-model="field.feature" :label="i18n['feature']"
                                      :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                      :rules="[rules.required]"></v-text-field>
                                  </v-col>

                                  <v-col cols="6">
                                    <v-btn x-small icon color="error" @click="removeField(index)">
                                      <v-icon size="35">mdi-delete-forever</v-icon>
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="6">

                                    <v-switch v-model="field.available"
                                      :class="[{ 'arFont': arabic, 'enFont': !arabic }]" label="Available"
                                      color="success">
                                    </v-switch>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>

                        <v-col cols="12">
                          <v-btn color="success" @click="addField_ar" class="mb-2"
                            :class="{ 'arFont': arabic, 'enFont': !arabic }" small>{{ i18n['add_feature_ar'] }}</v-btn>

                          <v-expansion-panels accordion>
                            <v-expansion-panel v-for="(field, index) in features_ar" :key="index">
                              <v-expansion-panel-header :class="{ 'arFont': arabic, 'enFont': !arabic }">
                                {{ i18n['feature_ar'] }} {{ index + 1 }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>

                                  <v-col cols="12">
                                    <v-text-field outlined dense v-model="field.feature_ar" :label="i18n['feature_ar']"
                                      :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                      :rules="[rules.required]"></v-text-field>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-btn x-small icon color="error" @click="removeField_ar(index)">
                                      <v-icon size="35">mdi-delete-forever</v-icon>
                                    </v-btn>
                                  </v-col>

                                  <v-col cols="6">

                                    <v-switch v-model="field.available_ar"
                                      :class="[{ 'arFont': arabic, 'enFont': !arabic }]" label="Available"
                                      color="success">
                                    </v-switch>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-btn small color="success" type="submit" block
                          :class="{ 'arFont': arabic, 'enFont': !arabic }">
                          {{ i18n['add_plan'] }}
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>




<script>
import axios from 'axios';

export default {
  data() {
    return {
      // initial data setup
      title: "",
      title_ar: "",
      description: "",
      description_ar: "",
      price_id: "",
      price: "",
      compare_price: "",
      loading: false,
      is_free:false,
      formErrors: {},
      features: [],
      features_ar: [],
      form_number: "",
      form_submissions: "",
      form_views: "",
      rules: {
        required: value => !!value || this.i18n['required'],
        string: value => (typeof value === 'string' || value instanceof String) || this.i18n['mustBeAString'],
        number: value => !isNaN(parseFloat(value)) && isFinite(value) || this.i18n['mustBeANumber'],
        requiredIfNotFree: value => this.is_free || (!!value && value.length > 0) || this.i18n['required'],

      },
    };
  },
  methods: {
    submitPlans() {
  if (this.$refs.form.validate()) {
    this.loading = true;

    // Prepare the payload for the putResource action
    const payload = {
      resource: `/update/plan/${this.$route.params.id}`,
      value: {
        is_free: this.is_free,
        title: this.title,
        title_ar: this.title_ar,
        description: this.description,
        description_ar: this.description_ar,
        price_id: this.is_free ? '' : this.price_id,
        price: this.price,
        compare_price: this.compare_price,
        form_number: this.form_number,
        form_submissions: this.form_submissions,
        form_views: this.form_views,
        features: this.features.map(f => ({ feature: f.feature, available: f.available })),
        features_ar: this.features_ar.map(f => ({ feature_ar: f.feature_ar, available_ar: f.available_ar }))
      }
    };

    // Dispatch the putResource action with the payload
    console.log(this.features,'-------------',this.features_ar)
    this.$store.dispatch('putResource', payload)
      .then(() => {
        this.loading = false;
        this.$router.push({ name: 'plan_list' });
      })
      .catch((error) => {
        this.loading = false;
        console.error("Error during plan submission:", error);
        if (error.response && error.response.status === 422) {
          this.formErrors = error.response.data.errors;
        } else {
          this.formErrors = { general: ["An unexpected error occurred."] };
        }
      });
  } else {
    console.error("Form validation failed");
  }
},

fetchPlanData() {
  // Prepare the payload for the getResource action
  const payload = {
    resource: `/show/plan/${this.id}`
  };

  this.$store.dispatch('getResource', payload)
    .then(response => {
      const planData = response;
      this.title = planData.title;
      this.title_ar = planData.title_ar;
      this.description = planData.description;
      this.description_ar = planData.description_ar;
      this.price_id = planData.price_id;
      this.price = planData.price;
      this.compare_price = planData.compare_price;
      this.form_number = planData.form_number;
      this.form_submissions = planData.form_submissions;
      this.form_views = planData.form_views;
      this.is_free = planData.is_free;

      try {
        this.features = JSON.parse(planData.features || '[]');
        this.features_ar = JSON.parse(planData.features_ar || '[]');
      } catch (e) {
        this.features = [];
        this.features_ar = [];
      }
    })
    .catch(error => {
      console.error("Error fetching plan data:", error);
    });
},

    addField() {
      this.features.push({ feature: '', available: false });
    },
    removeField(index) {
      this.features.splice(index, 1);
    },
    addField_ar() {
      this.features_ar.push({ feature_ar: "", available_ar: false });
    },
    removeField_ar(index) {
      this.features_ar.splice(index, 1);
    },
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },

    translatedFieldTypes() {
      return this.fieldTypes.map(type => ({
        key: type,
        name: this.i18n.fieldsType[type] || type
      }));
    },
  },

  mounted() {

    this.id = this.$route.params.id;
    if (this.id) {
      this.fetchPlanData();
    }
  },

}
</script>